import React from 'react'

export const Ventanas95logo = () => {
  return <img src="https://www.ventanas95.com/logo.svg" />
}
